import { useQuery } from '@tanstack/react-query'
import useApi from '@tabeeb/modules/shared/utils/API/hooks/useApi'
import { ArticlesQueryKeys } from '../queries'

export interface UseAnnouncementProps {
  id: number
  onError?: (error: unknown) => void
}

export const useAnnouncement = ({ id, onError }: UseAnnouncementProps) => {
  const { articleServiceApi: api } = useApi()

  const query = useQuery({
    queryKey: [ArticlesQueryKeys.Announcement, id],
    queryFn: () => api.announcements.getAsync(id),
    enabled: !!id,
    onError,
  })

  return {
    loading: query.isLoading,
    announcement: query.data,
    onReload: query.refetch,
  }
}

export default useAnnouncement
